import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  border-radius: 4px;
  border: none;
  box-shadow: none;
  padding: 8px 8px 8px 0px;
  background: inherit;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }

  :hover {
    background: #fed4d6;
    border: none;
    box-shadow: none;
  }

  :focus {
    background: #fdadb3;
    outline: white solid 2px;
    box-shadow: 0 0 0 4px #fdadb3;
  }

  :active {
    background: #fdadb3;
    border: none;
    outline: none;
    box-shadow: none;
  }
`;

export default Button;
